import { asQuantity, asQuantityOrNa } from '../utils/formatters';

export default [
  {
    displayString: 'Target Yield / tree',
    accessor: 'targetYieldPerTree',
    format: asQuantity,
  },
  {
    displayString: 'Average Yield at Maturity',
    accessor: 'averageYieldAtMaturity',
    format: asQuantityOrNa,
  },
  {
    displayString: 'Max Yield',
    accessor: 'maxYield',
    format: asQuantityOrNa,
  },
  {
    displayString: 'Year of Maturity',
    accessor: 'yearOfMaturity',
  },
];
